<template>
    <BaseModalNew :title="'Connect with Social'" @close="closeModal">
        <template #modalContent>
            <div class="bm-modal-content-wrapper">
                <div class="tabs">
                    <button v-for="tab in tabs" :key="tab" :class="['tab-button', { active: activeTab === tab }]"
                        @click="activeTab = tab">
                        {{ tab }}
                    </button>
                </div>
                <div class="bm-modal-content">
                    <div v-if="activeTab === 'Social'">
                        <GoogleLogin />
                    </div>
                </div>
            </div>
        </template>
    </BaseModalNew>
</template>

<script>
import BaseModalNew from "@/components/common/BaseModalNew.vue";
import GoogleLogin from "@/decast/components/v2auth/social-logins/GoogleLogin.vue";

export default {
    name: 'SocialLoginModal',
    props: ['closeModal'],
    components: {
        BaseModalNew,
        GoogleLogin,
    },
    data() {
        return {
            tabs: ['Social'], //'Platform', 'Government', 'Educational'
            activeTab: 'Social',
        };
    },
    methods: {
    },
}
</script>

<style scoped>
*:not(i) {
  /* font-family: 'Karla', sans-serif !important; */
  font-family: 'Rethink Sans' !important;
}

.menu-button {
    width: 196px;
    padding: 0.5rem;
    margin-top: 0.5rem;
    background-color: #FFFFFF;
    color: #000000;
}
.tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.tab-button {
  padding: 0.5rem 1.2rem;
  border: none;
  border-radius: 1.5rem;
  background-color: #2C3044;
  color: #FFFFFF70;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.3s ease;
}

.tab-button.active {
  background-color: #D3CA57;
  color: black;
}
</style>